/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { getJupiterQuote, JupiterQuoteRequest, JupiterQuoteResponse } from '../../lib/solana/jupiter';

export const jupiterApi = {
    /**
     * Get a quote for a swap
     */
    quote: async (params: JupiterQuoteRequest): Promise<JupiterQuoteResponse> => {
        try {
            return await getJupiterQuote(params);
        } catch (error) {
            console.error("Jupiter Quote API Error:", error);
            throw error;
        }
    },

    /**
     * Serialize a swap transaction (Mocked for demo)
     */
    swap: async (quoteResponse: JupiterQuoteResponse, userPublicKey: string) => {
        // In a real app, this calls https://quote-api.jup.ag/v6/swap
        await new Promise(resolve => setTimeout(resolve, 800)); // Simulate latency
        
        // Mock base64 encoded serialized transaction
        return {
            swapTransaction: btoa("mock_serialized_transaction_for_jupiter_" + Date.now()),
            lastValidBlockHeight: 123456789,
            prioritizationFeeLamports: 1000
        };
    }
};